import { cn } from '@/shared/lib/utils';
import React from 'react';

interface Props {
    className?: string;
}

export const Container: React.FC<React.PropsWithChildren<Props>> = ({ className, children }) => {
    return <div className={cn('mx-auto w-full max-w-[1920px] px-[22px] md:px-[32px] lg:px-[42px] 2xl:px-[200px]', className)}>{children}</div>;
};